export default __webpack_public_path__ + "static/media/151-deposit.63a49d4e.png";